import AjaxRequest from "../modules/ajax-request";
import Cookies from "js-cookie";

class NewsletterSubscription {
    constructor(element) {
        this.div = element;
        this.form = "";
        this.format = "";
        this.url = "";
        this.frequency = "";
        this.formFields = "";
        this.formFeedback = "";
        this.loadingElement = "";
        this.showRecaptcha = false;
        this.recaptchaLoaded = false;
        this.reCaptchaAction = "newsletter_subscription";
        this.reCaptchaWidget = "newsletter_subscription";
        this._ajaxCallData = [];

        this.init();
        this.getData();
        this.clearData();
        this.bindEvents();
    }

    init() {
        this.form = this.div.querySelector("form");
        this.loadingElement = this.div.querySelector(".add-load-element");
        this.formFields = this.form.querySelectorAll('[data-id="newsletter-subscription-form-field"]');
        this.formFeedback = this.form.querySelector('[data-id="form-feedback"]');
    }

    getData() {
        [
            this._id,
            this.format,
            this._ajaxCallData['url'],
            this._ajaxCallData['controller'],
            this._ajaxCallData['action'],
            this._ajaxCallData['method'],
            this._ajaxCallData['parameters'],
            this._ajaxCallData['payload'],
            this._ajaxCallData['signature'],
            this.showRecaptcha,
        ] = Object.values(this.div.dataset)
        if ((this.showRecaptcha === 1) || (this.showRecaptcha === "1")) {
            this.showRecaptcha = true;
        } else {
            this.showRecaptcha = false;
        }
    }

    clearData() {
        let attrs = Array.from(this.div.attributes).filter(attr => attr.name.startsWith('data-'));

        attrs.forEach(attr => this.div.removeAttribute(attr.name));
    }

    bindEvents() {
        let _this = this;

        if (this.format === "format-2") {
            this._onScroll = function () {
                _this.showModal();
            };
            document.addEventListener("scroll", this._onScroll);

            let _closeModalButton = this.div.querySelector('[data-id="widget-newsletter-subscription__close-modal"]');
            if (_closeModalButton !== null) {
                _closeModalButton.addEventListener("click", function () {
                    _this.closeModal();
                });
            }
        }

        this.form.addEventListener("submit", function (event) {
            if (_this.showRecaptcha === true) {
                _this.getRecaptcha3Token(event);
            } else {
                _this.submitForm(event);
            }
        });

        this.formFields.forEach(function (field) {
            field.addEventListener("click", function () {
                if (!_this.recaptchaLoaded) {
                    _this.recaptchaLoaded = true;
                    let _event = new CustomEvent('reCaptcha_domInjection');
                    document.dispatchEvent(_event);
                }
            });
        });

        document.addEventListener('recaptcha3_token_generated', function (event) {
            event.preventDefault();
            let _target = event.detail.target;
            if (_target === _this.reCaptchaWidget) {
                _this.addRecaptchaToken(event);
                _this.submitForm(event);
            }
        });
    }

    showModal() {
        if (window.scrollY > 400) {
            let _showModal = Cookies.get('dissmiss-modal');
            if (parseInt(_showModal) !== 1) {
                this.div.style.opacity = '0';
                this.div.style.display = '';
                setTimeout(() => {
                    this.div.style.transition = 'opacity 0.1s ease-in-out';
                    this.div.style.opacity = '1';
                }, 0);
                document.documentElement.classList.add('no-scroll');
                document.removeEventListener('scroll', this._onScroll);
            }
        }
    }

    closeModal() {
        Cookies.set('dissmiss-modal', 1, { expires: this.frequency });
        this.div.style.transition = 'opacity 0.1s ease-in-out';
        this.div.style.opacity = '0';
        setTimeout(() => {
            this.div.style.display = 'none';
        }, 100);
        document.documentElement.classList.remove('no-scroll');
    }

    getRecaptcha3Token(event) {
        event.preventDefault();
        let _eventDetail = { 'detail': { 'origin': this.reCaptchaWidget, 'action': this.reCaptchaAction } };
        let _event = new CustomEvent('recaptcha3_generate_token', _eventDetail);
        document.dispatchEvent(_event);
    }

    addRecaptchaToken(event) {
        event.preventDefault();
        let _recaptcha3Input = this.form.querySelector('#newsletter_subscription_recaptcha3');
        if (_recaptcha3Input !== null) {
            _recaptcha3Input.setAttribute("value", event.detail.token);
        }
    }

    submitForm(event) {
        event.preventDefault();

        let _this = this;
        let _loadingElement = this.loadingElement;

        let ajaxRequest = new AjaxRequest({
            elementToAddLoading: _loadingElement,
            successCallback: function (response) {
                _this.form.innerHTML = response.message;
                _this.init();
                _this.formFeedback.classList.add("is-success");
                _this.clearFormFields();
            },
            errorCallback: function (response) {
                _this.form.innerHTML = response.responseJSON.message;
                _this.init();
                _this.formFeedback.classList.add("is-failure");
                _this.clearFormFields();
            }
        });

        this.formFeedback.classList.remove("is-success");
        this.formFeedback.classList.remove("is-failure");

        let _formData = Object.fromEntries(new FormData(this.form).entries());

        let _url = this._ajaxCallData['url'];
        ajaxRequest.makeCall(_url, Object.assign({
            "controller": this._ajaxCallData['controller'],
            "action": this._ajaxCallData['action'],
            "method": this._ajaxCallData['method'],
            "_parameters": this._ajaxCallData['parameters'],
            "payload": this._ajaxCallData['payload'],
            "signature": this._ajaxCallData['signature']
        }, _formData));
    }

    clearFormFields() {
        let _privacyCheckBox = this.form.querySelector('#newsletter_subscription_privacy');
        if (_privacyCheckBox !== null) {
            _privacyCheckBox.checked = false;
        }

        let _event = new CustomEvent("recaptcha_reset");
        document.dispatchEvent(_event);
    }
}

export default NewsletterSubscription;